<template>
  <div
    class="popup-box flex flex-column"
    style="position: relative; padding: 10px"
  >
    <el-form
      :model="state.model"
      ref="formDom"
      style="width: 100%; margin-top: 10px"
    >
      <el-form-item label="自定义模板"
        ><el-switch
          v-model="state.model.salary_template_type"
          inline-prompt
          active-text="启用"
          inactive-text="禁用"
          :active-value="1"
          :inactive-value="0"
          disabled
      /></el-form-item>
      <el-form-item label="模板字段" style="display: flex; align-items: center">
        <div style="width: 100%">
          <ul style="margin-top: 10px">
            <transition-group class="container" name="sort">
              <el-tag
                v-for="item in state.model.fieldsArr"
                :key="item"
                type="primary"
                style="margin-right: 10px; position: relative"
                :draggable="true"
                @dragstart="dragstart(item)"
                @dragenter="dragenter(item, $event)"
                @dragend="getDragend"
              >
                {{ item }}
                <!-- <div class="customer-tag-shade">
                  <el-icon color="#fff" size="70"><Back /></el-icon>
                  <li style="flex: 1"></li>
                  <el-icon color="#fff" size="40"><Right /></el-icon>
                </div> -->
              </el-tag>
            </transition-group>
          </ul>
        </div>
      </el-form-item>
      <el-form-item label=" ">
        <el-button type="warning" @click="onDownLoad">模板下载</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { salarytemplate_info, salarytemplate_download } from "@/http/api";

export default {
  setup() {
    const formDom = ref(null);
    const state = reactive({
      model: {
        status: 1,
        fieldsArr: [],
      },
      fields: ["岗位工资", "补贴/津贴", "绩效/提成", "税前加项", "税前减项"],
    });

    onMounted(() => {
      salarytemplate_info().then((res) => {
        if (res.status == 200) {
          state.model = res.data.data;

          if (state.model.fields) state.model.fieldsArr = state.model.fields;
          else state.model.fieldsArr = [];
        }
      });
    });

    const onDownLoad = () => {
      salarytemplate_download().then((res) => {
        //通过后台返回 的word文件流设置文件名并下载
        var blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        var downloadElement = document.createElement("a");
        var href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        downloadElement.download = "工资表模板.xlsx"; //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
      });
    };

    const dragstart = (value) => {
      state.oldData = value;
      state.dragStartId = value;
    };
    const dragenter = (value) => {
      state.newData = value;
      state.dragEndId = value;
    };
    const getDragend = () => {
      if (state.oldData !== state.newData) {
        let oldIndex = state.model.fieldsArr.indexOf(state.oldData);
        let newIndex = state.model.fieldsArr.indexOf(state.newData);
        let newItems = [...state.model.fieldsArr];
        // 删除之前DOM节点
        newItems.splice(oldIndex, 1);
        // 在拖拽结束目标位置增加新的DOM节点
        newItems.splice(newIndex, 0, state.oldData);
        // 每次拖拽结束后，将拖拽处理完成的数据，赋值原数组，使DOM视图更新，页面显示拖拽动画
        state.model.fieldsArr = newItems;
        // 每次拖拽结束后调用接口时时保存数据
      }
    };
    return {
      state,
      formDom,
      dragstart,
      dragenter,
      getDragend,
      onDownLoad,
    };
  },
};
</script>
<style scoped lang="less"></style>
